import { createSelector } from '@reduxjs/toolkit';
import { selectRegionId } from '../location';
import { selectIsProfessionalSearchSearchAvailable } from './selectIsProfessionalSearchBannerAvailable';
import { MOSCOW_AND_REGION_ID, MOSCOW_ID, MOSCOW_REGION_ID } from 'shared/constants/regions';

export const selectIsProfessionalSearchBannerVisible = createSelector(
  [selectRegionId, selectIsProfessionalSearchSearchAvailable],
  (regionId, professionalSearchAvailable) => {
    const isInRegion = [MOSCOW_ID, MOSCOW_REGION_ID, MOSCOW_AND_REGION_ID].includes(regionId);

    return professionalSearchAvailable && !isInRegion;
  },
);
